/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const ko_course_multilingualhelptext2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`원하는 언어로 제목과 설명을 작성하세요. 최소 하나의 언어는 필요합니다.`)
};

const en_course_multilingualhelptext2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write titles and descriptions in your preferred language. At least one language is required.`)
};

const ja_course_multilingualhelptext2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お好みの言語でタイトルと説明を書いてください。少なくとも1つの言語が必要です。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "ko" | "en" | "ja" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const course_multilingualhelptext2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.course_multilingualhelptext2(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("course_multilingualhelptext2", locale)
	if (locale === "ko") return ko_course_multilingualhelptext2(inputs)
	if (locale === "en") return en_course_multilingualhelptext2(inputs)
	return ja_course_multilingualhelptext2(inputs)
};
export { course_multilingualhelptext2 as "course_multilingualHelpText" }